export const regionalanalyseRequest = (dataset) => {
  return {
    url: url().sparebank + dataset,
    transform: (body) => ({
      apiResultByDataset: {
        [dataset]: body,
      },
    }),
    update: {
      apiResultByDataset: (prev, next) => {
        return {
          ...prev,
          ...next,
        };
      },
    },
  };
};

export const duckyRequest = (region) => {
  return {
    url: url().ducky + "byRegion/" + region,
    transform: (body) => ({
      duckyResultByRegion: {
        [region]: body,
      },
    }),
    update: {
      duckyResultByRegion: (prev, next) => {
        return {
          ...prev,
          ...next,
        };
      },
    },
  };
};

export const navRequest = (props) => {
  return {
    url: url().nav,
    transform: (body) => ({
      navResult: body,
    }),
    update: {
      navResult: (prev, next) => {
        return next;
      },
    },
  };
};

export const apiRequest = (props) => {
  const { query, gid, tableId, cityIndexes, timeType } = props;
  let body = {
    ssbTableId: tableId,
    query: JSON.parse(query),
    regions: cityIndexes,
    timeType: timeType,
  };
  return {
    url: url().ssb,
    options: {
      method: "POST",
    },
    body: body,
    transform: (body) => ({
      apiResultByGid: {
        [gid]: body,
      },
    }),
    update: {
      apiResultByGid: (prev, next) => {
        return {
          ...prev,
          ...next,
        };
      },
    },
  };
};

export const apiMutation = (props) => {
  const { query, tableId, cityIndexes, timeType, gid } = props;

  let body = {
    ssbTableId: tableId,
    query: JSON.parse(query),
    regions: cityIndexes,
    timeType: timeType,
  };

  return {
    url: url().ssb,
    options: {
      method: "POST",
    },
    body: body,
    transform: (body) => ({
      apiResultByGid: {
        [gid]: body,
      },
    }),
    update: {
      apiResultByGid: (prev, next) => {
        return {
          ...prev,
          ...next,
        };
      },
    },
  };
};

const url = () => {
  // return {
  //   ssb: "https://localhost:7087/api/ssb",
  //   sparebank: "https://localhost:7087/api/sparebank/",
  //   nav: "https://localhost:7087/api/nav",
  //   ducky: "https://localhost:7087/api/ducky/",
  // };
  return {
    ssb: "https://sb1-konjunkturbarometer-api.azurewebsites.net/api/ssb",
    sparebank: "https://sb1-konjunkturbarometer-api.azurewebsites.net/api/sparebank/",
    nav: "https://sb1-konjunkturbarometer-api.azurewebsites.net/api/nav/",
    ducky: "https://sb1-konjunkturbarometer-api.azurewebsites.net/api/ducky/",
  };
};
